<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-profil
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <!-- Main -->
        <main class="profileDashboard --messages">
            <div class="container">
                <div class="row">

                    <!-- Menu -->
                    <menu-profil
                        :profil="profil"
                        :spravy="spravy"
                    />

                    <!-- Správy -->
                    <div v-if="profil.pouzivatel_id" class="col-xs-12 col-md-12 col-lg-8 col-xl-9">
                        <div class="header d-flex align-items-center justify-content-between">
                            <h2>Správy</h2> 
                            <a @click="setMessagesAsReaded(profil.pouzivatel_id.id)" class="read-all">
                                <span class="icon"></span>Označiť všetky ako prečítané
                            </a>
                        </div>
                        <br>

                        <!-- Alert box -->
                        <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                            <span :class="'icon --'+responseType"></span>{{ responseText }}
                        </div>

                        <!-- Message Box -->
                        <div class="accordion" id="accordionExample">
                            <div v-for="(message, index) in sortedMessages" class="card">
                                <!-- Title -->
                                <div class="card-header" @click="collapseMessage(index); setMessageAsReaded(message.id, index)">
                                    <span class="date">{{ message.created_at.replace(/-/g, ".").replace(/:..$/g, "") }}</span>
                                    <a v-if="!message.message_flag">
                                        {{ message.message_title }}
                                    </a>
                                    <a v-else style="font-weight:300">
                                        {{ message.message_title }}
                                    </a>
                                </div>

                                <!-- Message -->
                                <div v-show="collapse[index]" class="collapse show">
                                    <div v-html="message.message_sprava" class="card-body">
                                        {{ message.message_sprava }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- .Message Box -->

                    </div>
                    <!-- .Správy -->

                </div>
            </div>
        </main>

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderProfil from '../partials/HeaderProfil.vue'
    import MenuProfil   from '../partials/MenuProfil.vue'
    export default {
        components: {
            HeaderProfil,
            MenuProfil
        },
        props: [
            'profil',
            'spravy'
        ],
        mounted() {
        },
        data() {
            return {
                collapse: [],
                message_flag: [],

                responseType: '',
                responseText: ''
            }
        },
        computed: {
            sortedMessages() {
                return this.profil.pouzivatel_id.spravy_pouzivatela.sort( function( a, b ){
                        return ( ( a.created_at == b.created_at ) ? 0 : ( ( a.created_at < b.created_at ) ? 1 : -1 ) )
                       })
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // click
            setMessageAsReaded(message_id, index) {
                if (this.message_flag[index] != 1 && this.profil.pouzivatel_id.spravy_pouzivatela[index].message_flag != 1) {
                    EventService.setMessageAsReaded(message_id)
                        .then(response => {
                            //console.log(response.data)
                            this.message_flag[index] = 1
                            this.profil.pouzivatel_id.spravy_pouzivatela[index].message_flag = 1
                            this.$emit('update:profil', this.profil)

                            if (parseInt(this.spravy) > 0) {
                                var count_spravy = parseInt(this.spravy) - 1
                                this.$emit('update:spravy', count_spravy)
                            }
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            },

            setMessagesAsReaded(pouzivatel_id) {
                EventService.setMessagesAsReaded(pouzivatel_id)
                    .then(response => {
                        //console.log(response.data)
                        this.responseType = response.data.code
                        this.responseText = response.data.data

                        if (response.data.code == 'success') {
                            for (var i = 0; i < this.profil.pouzivatel_id.spravy_pouzivatela.length; i++) {
                                this.profil.pouzivatel_id.spravy_pouzivatela[i].message_flag = 1
                            }
                            this.$emit('update:profil', this.profil)

                            this.message_flag = new Array(this.profil.pouzivatel_id.spravy_pouzivatela.length).fill(1)
                            this.$emit('update:spravy', 0)
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },

            collapseMessage(index) {
                this.$set(this.collapse, index, !this.collapse[index])
            }
        }
    }
</script>